// extracted by mini-css-extract-plugin
export default {"quickSearch":"FilterInput__quickSearch--kuYp4"};